import {
  ProfileContext,
  ProfileContextType,
} from '@/providers/profileProvider';
import { useContext } from 'react';

export const useProfile = (): ProfileContextType => {
  return useContext(ProfileContext) as ProfileContextType;
};
